import { render, staticRenderFns } from "./inquiries.vue?vue&type=template&id=06beafca&"
import script from "./inquiries.vue?vue&type=script&lang=js&"
export * from "./inquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports